import { get } from "lodash";
import { postFiles } from "../apis/files";
import { viewLoading } from "./loading";
import systemAlert from "./systemAlert";
import { imageCompression } from "./image";

export const fileUpload = async (file, isNotLoading, isNotCompression = false) => {
  return new Promise(async (resolve, reject) => {

    if (file.size / 1024 / 1024 > 20) {
      systemAlert('20MB 이상 파일은 올릴 수 없습니다.');
      return reject();
    }

    if (!isNotLoading) {
      viewLoading(true);
    }

    if (file.type.indexOf('image') > -1) {
      if (file.size / 1024 / 1024 > 1 && !isNotCompression) {
        file = await imageCompression(file);
      }
    }


    const originFile = {
      formattedSize: file.formattedSize,
      size: file.size,
      name: (file.name || "").normalize("NFC"),
      path: file.path,
      type: file.type,
      preview: file.preview,
      file
    };
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", (file.name || "").normalize("NFC"));

    postFiles(formData)
      .then((res) => {
        resolve({ fileUrl: res.data.fileUrl, ...originFile, fileIdx: get(res, 'data.fileIdx') });
      })
      .catch((err) => {
        reject(err);
      })
      .finally(() => {
        if (!isNotLoading) {
          viewLoading(false);
        }
      });
  });
};


export const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export const dataURLtoFile = (dataurl, fileName) => {
  let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], fileName, { type: mime });
};